import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectHostsSelected } from 'store/HostsGeneral/selectors';
import { selectHostRow, unselectTotalHosts } from 'store/HostsGeneral/actions';
import SelectionCell from 'shared/ui/Table/cells/SelectionCell';

export const CheckColum = ({ host }) => { // eslint-disable-line import/prefer-default-export
  const hostsSelected = useSelector((state) => selectHostsSelected(state));
  const dispatch = useDispatch();
  const isSelected = hostsSelected.find((hostSelected) => hostSelected._id === host._id);
  const handleClick = (e) => {
    dispatch(unselectTotalHosts());
    dispatch(selectHostRow(e, host));
  };

  return (
    <SelectionCell checked={ !!isSelected } onChange={ handleClick } />
  );
};
